<ion-content class="w-full h-full">
  <div class="w-full h-full flex justify-center items-center">
    <div class="flex flex-col items-center gap-4">
      <ion-icon [name]="icon()" [color]="color()"></ion-icon>
      <ion-text [color]="color()" class="text-lg">{{ label() }}</ion-text>
    </div>
  </div>
  @if (lessonsTutorial() || studentsTutorial() || officeTutorial()) {
  <ion-button
    fill="clear"
    class="absolute bottom-4 left-0 right-0 mx-6"
    (click)="startTour()"
  >
    <ion-label>Anleitung ansehen</ion-label>
  </ion-button>
  }
</ion-content>